export default __webpack_public_path__ + "static/media/ck_logo.5e8c0279.png";